import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ConfirmDeletePrice.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ConfirmDeletePrice extends Component {

    toggleConfirmDeletePrice = () => {
        this.props.toggleConfirmDeletePrice();
    }

	toggle = () => {
        this.toggleConfirmDeletePrice(false);
    }

    confirmDeletePrice = () => {
        this.toggleConfirmDeletePrice(false);
        this.props.confirmDeletePrice();
    }

	componentWillMount() {
        this.setState({
			modal: this.props.isConfirmDeletePriceOpen
		});
    }
    
    componentWillReceiveProps() {
        this.setState({
			modal: this.props.isConfirmDeletePriceOpen
		});
	}

	render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isConfirmDeletePriceOpen} toggle={this.toggle}>
		          	<ModalHeader toggle={this.toggle}>{strings.title}</ModalHeader>
		          	<ModalBody>
                        {ReactHtmlParser(strings.description)}
		          	</ModalBody>
                    <ModalFooter className="justify-content-center">
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={this.confirmDeletePrice}>
                            {strings.ok}
                        </button>
                        <button
                            className="showtix-button showtix-background__grey-1"
                            onClick={this.toggle}>
                            {strings.cancel}
                        </button>
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

ConfirmDeletePrice.propTypes = {
    isConfirmDeletePriceOpen: PropTypes.bool,
    toggleConfirmDeletePrice: PropTypes.func,
    confirmDeletePrice: PropTypes.func
}

export default ConfirmDeletePrice;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/ConfirmDeletePrice/ConfirmDeletePrice.js